import { Element, Component, Host, h, Prop, Event, EventEmitter, Watch } from '@stencil/core';

// Inspired by https://codepen.io/evth/pen/zBNqrL

@Component({
  tag: 'zpr-progress-ring'
})
export class ZprProgressRing {

  @Prop() size: number = 20; // pixels
  @Prop() stroke?: number = 25; // percentage
  @Prop({ mutable:true }) progress: number = 0;

  render() {
    if (this.progress < 0) {
      this.progress = 0;
    } else if (this.progress > 100) {
      this.progress = 100;
    }
    const stroke = this.stroke;
    const circumference = 315;
    const offset = circumference - (this.progress * circumference / 100);
    return <Host role="progressbar">
      <svg height={this.size} width={this.size} viewBox={`-${stroke / 2} -${stroke / 2} ${100 + stroke} ${100 + stroke}`} xmlns="http://www.w3.org/2000/svg" version="1.1">
        <circle
          stroke-dasharray={circumference}
          stroke-dashoffset="0"
          stroke-width={stroke}
          fill="transparent"
          r="50"
          cx="50"
          cy="50"
        />
        <circle
          stroke-dasharray={circumference}
          style={{"stroke": "#4A90E2", "stroke-dashoffset": offset.toString()}}
          stroke-width={stroke}
          fill="transparent"
          r="50"
          cx="50"
          cy="50"
        />
      </svg>
    </Host>
  }
}
